module.exports = __webpack_public_path__ + "images/emoji/children_crossing.3455a37d10c006f85dd3.png";